var map = {
	"./icon_pc_de.png": 675068,
	"./icon_pc_es.png": 275426,
	"./icon_pc_eu.png": 686484,
	"./icon_pc_fr.png": 829393,
	"./icon_pc_it.png": 631013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 737678;